import { render, staticRenderFns } from "./supplierdetails.vue?vue&type=template&id=23ed67db&scoped=true&"
import script from "./supplierdetails.vue?vue&type=script&lang=js&"
export * from "./supplierdetails.vue?vue&type=script&lang=js&"
import style0 from "./supplierdetails.vue?vue&type=style&index=0&id=23ed67db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ed67db",
  null
  
)

export default component.exports